import React, { useEffect, useState } from "react";
import { Button, Row, Col, Form, Container, Card } from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";
import api from "../api/api";
import "./Reports.css";

const Reports = () => {
  const [listFields, setListFields] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [listReports, setListReports] = useState([]);
  const [filename, setFileName] = useState("");
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [farms, setFarms] = useState([]);
  const [fields, setFields] = useState([]);
  const [reports, setReports] = useState([]);

  const role = JSON.parse(localStorage.getItem("user") || "{}").role;

  useEffect(() => {
    const getListFields = async () => {
      try {
        await api
          .get("/field/fields")
          .then((response) => {
            let fields = [];
            let reports = [];
            let result = response.data.farms;
            if (result) {
              result.map((farms) => {
                let fieldData = farms.fields;
                if (fieldData) {
                  fieldData.map((field) => {
                    fields.push({
                      id: field.id,
                      name: field.name,
                    });
                    let reportsData = field.reports;
                    if (reportsData) {
                      reportsData.map((item) => {
                        reports.push({
                          id: item.id,
                          fieldId: item.field_id,
                          file: item.filename,
                        });
                      });
                    }
                  });
                }
              });
              setListReports(reports);
              setListFields(fields);
              if (fields.length > 0) {
                setSelectedField(fields[0].id);
              }
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {
        console.error(error);
      }
    };
    const getMyUsers = async () => {
      await api
        .get("/supplier/get-users")
        .then((response) => {
          let usersList = response.data.users;
          setUsers(usersList);
          let Fields = [];
          let Reports = [];
          if (usersList.length > 0) {
            usersList.map((data) => {
              let farmsList = data.farms;
              if (farmsList.length > 0) {
                setFarms(farmsList);
                farmsList.map((farm) => {
                  let fieldsList = farm.fields;
                  if (fieldsList.length > 0) {
                    fieldsList.map((field) => {
                      Fields.push({
                        id: field.id,
                        uid: field.uid,
                        farmId: field.farm_id,
                        name: field.name,
                        Latitude: field.Latitude,
                        Longitude: field.Longitude,
                        status: field.status,
                      });
                      let reportsList = field.reports;
                      if (reportsList.length > 0) {
                        reportsList.map((sensor) => {
                          Reports.push({
                            fieldId: sensor.field_id,
                            filename: sensor.filename,
                            userId: sensor.user_id,
                          });
                        });
                      }
                    });
                  }
                });
              }
            });
            setFields(Fields);
            setReports(Reports);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getMyUsers();
    getListFields();
  }, []);
  
  const selectSearch = [
    { value: "week", label: t("last_week") },
    { value: "custom", label: t("custom_range") },
  ];

  const handleClick = async (file) => {
    try {
      let data = { filename: file };
      const response = await api.post("/report/download", data, {
        responseType: "blob",
      });

      // Check if the response is a valid Blob
      if (!(response.data instanceof Blob)) {
        console.error("Invalid response data. Expected Blob.");
        return;
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "historique.pdf";
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.error("Error downloading report:", error);
    }
  };

  const filterReport = listReports.filter((report) => {
    return selectedField === "" || selectedField == report.fieldId;
  });

  const filterAllReports = reports.filter((report) => {
    return selectedField === "" || selectedField == report.fieldId;
  });

  const formatReportName = (file) => {
    if (!file) return t("report");
    return file.length > 58 ? file.slice(37, 58) : file;
  };

  const renderEmptyState = (message) => (
    <div className="reports-empty-state">
      <span className="reports-empty-icon">
        <i className="fas fa-file-circle-xmark" aria-hidden="true" />
      </span>
      <strong>{message}</strong>
      <small>{t("no_data_available")}</small>
    </div>
  );

  return (
    <Container fluid className="main-content-container reports-page">
      <Row noGutters className="reports-page-header">
        <PageTitle
          sm="4"
          title={t("reports")}
          subtitle={t("overview")}
          className="reports-page-title text-sm-left"
        />
        <Col xs="12" sm="auto" className="reports-header-mark">
          <span><i className="fas fa-file-invoice" aria-hidden="true" /></span>
          <div>
            <strong>{t("my_reports")}</strong>
            <small>{t("download", { defaultValue: "Télécharger vos rapports" })}</small>
          </div>
        </Col>
      </Row>
      <section className="reports-filters-card">
        <div className="reports-section-heading">
          <span className="reports-section-icon"><i className="fas fa-sliders-h" aria-hidden="true" /></span>
          <div>
            <h5>{t("filters", { defaultValue: "Filtres" })}</h5>
            <p>{t("select_field")}</p>
          </div>
        </div>
      <Row className="reports-filter-grid">
        <Col>
          <Form.Group>
            <label htmlFor="">{t("fields")}</label>
            <Form.Select
              value={selectedField}
              onChange={(e) => setSelectedField(e.target.value)}
            >
              <option value="">{t("select_field")}</option>
              {listFields.map((field) => (
                <option key={field.id} value={field.id}>{field.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        {role === "ROLE_SUPPLIER" ? (
          <Col>
            <Form.Group>
              <label htmlFor="">{t("clients_fields")}</label>
              <Form.Select
                value={selectedField}
                onChange={(e) => setSelectedField(e.target.value)}
              >
                <option value="">{t("select_field")}</option>
                {fields.map((field) => (
                  <option key={field.id} value={field.id}>{field.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        ) : null}
        <Col>
          <Form.Group>
            <label htmlFor="">{t("report_period")}</label>
            <Form.Select
              value={selectedRange}
              onChange={(e) => setSelectedRange(e.target.value)}
            >
              <option value="">{t("select_period")}</option>
              {selectSearch.map(({ value, label }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {selectedRange === "custom" ? (
            <Form.Group>
              <Form.Label>{t("start_date")}</Form.Label>
              <Form.Control
                type="datetime-local"
                placeholder={t("start_date")}
                disabled
                title={t("feature_not_available")}
              />
              <Form.Label>{t("end_date")}</Form.Label>
              <Form.Control
                type="datetime-local"
                placeholder={t("end_date")}
                disabled
                title={t("feature_not_available")}
              />
            </Form.Group>
          ) : null}
        </Col>
      </Row>
      </section>
      <Card className="reports-content-card">
        <Card.Header className="reports-content-header">
          <div className="reports-section-heading">
            <span className="reports-section-icon"><i className="fas fa-folder-open" aria-hidden="true" /></span>
            <div>
              <h5>{t("my_reports")}</h5>
              <p>{t("reports")}</p>
            </div>
          </div>
        </Card.Header>
        <Row className="reports-columns">
          <Col className="reports-column">
            <div className="reports-column-title"><i className="fas fa-user" aria-hidden="true" />{t("my_reports")}</div>
            <div className="reports-list">
              {filterReport.length === 0 && renderEmptyState(t("my_reports"))}
              {filterReport.map((report, index) => {
                return (
                  <div
                    key={report.id || `${report.file}-${index}`}
                    className="report-item"
                  >
                    <div className="report-item-name">
                      <span className="report-file-icon"><i className="fas fa-file-pdf" aria-hidden="true" /></span>
                      <h6>{t("field_report")} <small>{formatReportName(report.file)}</small></h6>
                    </div>
                    <button
                      className="report-download-button"
                      aria-label={t("download")}
                      onClick={() => handleClick(report.file)}
                    >
                      <i className="fas fa-download" aria-hidden="true" />
                    </button>
                  </div>
                );
              })}
            </div>
          </Col>
          {role === "ROLE_SUPPLIER" ? (
            <Col className="reports-column reports-column-secondary">
              <div className="reports-column-title"><i className="fas fa-users" aria-hidden="true" />{t("clients_reports")}</div>

              <div className="reports-list">
                {filterAllReports.length === 0 && renderEmptyState(t("clients_reports"))}
                {filterAllReports.map((report, index) => {
                  let userName = "";
                  users.map((user) => {
                    if (user.id === report.userId) {
                      userName = user.name;
                    }
                  });
                  return (
                    <div
                      key={`${report.filename}-${report.userId || index}`}
                      className="report-item"
                    >
                      <h6>
                        ► {userName} {t("field_report")}{" "}
                        {formatReportName(report.filename)}
                      </h6>
                      <button
                        className="report-download-button"
                        aria-label={t("download")}
                        onClick={() => handleClick(report.filename)}
                      >
                        <i className="fas fa-download" aria-hidden="true" />
                      </button>
                    </div>
                  );
                })}
              </div>
            </Col>
          ) : null}
        </Row>
      </Card>
    </Container>
  );
};

export default Reports;
